export const REQUEST_COMPANY = 'admin/REQUEST_COMPANY';
export const RECEIVE_COMPANY = 'admin/RECEIVE_COMPANY';

export const REQUEST_CREATE_COMPANY = 'admin/REQUEST_CREATE_COMPANY';
export const REQUEST_CREATE_COMPANY_SUCCESS = 'admin/REQUEST_CREATE_COMPANY_SUCCESS';
export const REQUEST_CREATE_COMPANY_FAILED = 'admin/REQUEST_CREATE_COMPANY_FAILED';

export const REQUEST_COMPANIES_CSV = 'companies/REQUEST_COMPANIES_CSV'; 
export const RECEIVE_COMPANIES_CSV = 'companies/RECEIVE_COMPANIES_CSV';

export const REQUEST_COMPANY_LIST = 'admin/REQUEST_COMPANY_LIST';
export const RECEIVE_COMPANY_LIST = 'admin/RECEIVE_COMPANY_LIST';

export const REQUEST_INSURANCE_COMPANY_LIST = 'companies/REQUEST_INSURANCE_COMPANY_LIST';
export const RECEIVE_INSURANCE_COMPANY_LIST = 'companies/RECEIVE_INSURANCE_COMPANY_LIST';

export const REQUEST_COMPANY_DROPDOWN = 'dropdowns/REQUEST_COMPANY_DROPDOWN'; 
export const RECEIVE_COMPANY_DROPDOWN = 'dropdowns/RECEIVE_COMPANY_DROPDOWN'; 

export const REQUEST_COMPANY_UPDATE = 'companies/REQUEST_COMPANY_UPDATE';
export const REQUEST_COMPANY_UPDATE_SUCESS = 'companies/REQUEST_COMPANY_UPDATE_SUCESS';
export const REQUEST_COMPANY_UPDATE_FAILED = 'companies/REQUEST_COMPANY_UPDATE_FAILED';

// company files
export const REQUEST_COMPANY_FILES = 'companies/REQUEST_COMPANY_FILES';
export const RECEIVE_COMPANY_FILES = 'companies/RECEIVE_COMPANY_FILES';

export const REQUEST_UPLOAD_COMPANY_FILE = 'companies/REQUEST_UPLOAD_COMPANY_FILE';
export const REQUEST_UPLOAD_COMPANY_FILE_SUCCESS = 'companies/REQUEST_UPLOAD_COMPANY_FILE_SUCCESS';
export const REQUEST_UPLOAD_COMPANY_FILE_FAILED = 'companies/REQUEST_UPLOAD_COMPANY_FILE_FAILED';

export const REQUEST_DELETE_COMPANY_FILE = 'companies/REQUEST_DELETE_COMPANY_FILE';
export const REQUEST_DELETE_COMPANY_FILE_SUCCESS = 'companies/REQUEST_DELETE_COMPANY_FILE_SUCCESS';
export const REQUEST_DELETE_COMPANY_FILE_FAILED = 'companies/REQUEST_DELETE_COMPANY_FILE_FAILED';

// company file types
export const REQUEST_COMPANY_FILE_TYPES_LIST = 'companies/REQUEST_COMPANY_FILE_TYPES_LIST';
export const RECEIVE_COMPANY_FILE_TYPES_LIST = 'companies/RECEIVE_COMPANY_FILE_TYPES_LIST';

export const REQUEST_ADD_COMPANY_FILE_TYPE = 'companies/REQUEST_ADD_COMPANY_FILE_TYPE';
export const REQUEST_ADD_COMPANY_FILE_TYPE_SUCCESS = 'companies/REQUEST_ADD_COMPANY_FILE_TYPE_SUCCESS';
export const REQUEST_ADD_COMPANY_FILE_TYPE_FAILED = 'companies/REQUEST_ADD_COMPANY_FILE_TYPE_FAILED';

export const REQUEST_COMPANY_UPDATE_FILE_TYPE = 'companies/REQUEST_COMPANY_UPDATE_FILE_TYPE';
export const REQUEST_COMPANY_UPDATE_FILE_TYPE_SUCCESS = 'companies/REQUEST_COMPANY_UPDATE_FILE_TYPE_SUCCESS';
export const REQUEST_COMPANY_UPDATE_FILE_TYPE_FAILED = 'companies/REQUEST_COMPANY_UPDATE_FILE_TYPE_FAILED';

export const REQUEST_COMPANY_FILE_TYPES_DD = 'dropdowns/REQUEST_COMPANY_FILE_TYPES_DD';
export const RECEIVE_COMPANY_FILE_TYPES_DD = 'dropdowns/RECEIVE_COMPANY_FILE_TYPES_DD';

export const REQUEST_FILE_TYPE_SECTIONS = 'REQUEST_FILE_TYPE_SECTIONS';
export const RECEIVE_FILE_TYPE_SECTIONS = 'RECEIVE_FILE_TYPE_SECTIONS';

// dropdowns
export const REQUEST_ALL_COMPANIES_DD = 'dropdowns/REQUEST_ALL_COMPANIES_DD'; 
export const RECEIVE_ALL_COMPANIES_DD = 'dropdowns/RECEIVE_ALL_COMPANIES_DD'; 

export const REQUEST_AGENT_COMPANY_DD = 'dropdowns/REQUEST_AGENT_COMPANY_DD'; 
export const RECEIVE_AGENT_COMPANY_DD = 'dropdowns/RECEIVE_AGENT_COMPANY_DD'; 

export const REQUEST_INS_COMPANY_DD = 'dropdowns/REQUEST_INS_COMPANY_DD'; 
export const RECEIVE_INS_COMPANY_DD = 'dropdowns/RECEIVE_INS_COMPANY_DD'; 

export const REQUEST_MORTGAGE_COMPANY_DD = 'dropdowns/REQUEST_MORTGAGE_COMPANY_DD'; 
export const RECEIVE_MORTGAGE_COMPANY_DD = 'dropdowns/RECEIVE_MORTGAGE_COMPANY_DD'; 